import { HubXAnalytics } from '@hubxtech/hubx-client-analytics-package/lib/src/apps/deepsearch';
import { PlatformEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/platformEnum';

import { appConfig } from './config';

export const hubxAnalytic = new HubXAnalytics({
  app: appConfig.analyticsApp,
  platform: PlatformEnum.WEB,
  pauseEventSending: appConfig.analyticsApp === null,
});
